/**
 * Created by Kieran on 16/09/2017.
 */

//pass vue component context to update a 'connected' property state

class IOManager {
  constructor() {
  }
  ConnectivityStatusWithAppState(context) {
    let self = this;
    context.$nextTick(function () {
        if (!navigator.onLine) {
          context.connected = false;
        }
        else {
          context.connected = true;
        }
      }
    );
  }
}

export default IOManager;





// WEBPACK FOOTER //
// ./src/helpers/IOManager/index.js